import { Pipe, PipeTransform } from '@angular/core';
import { FacetConfigResponse as FacetGroup } from '@models/api-search.models';

/**
 * Find matching group and returns group text together with a join symbol
 * Used in addition to toFacetExposedCollection pipe or ensure input is
 * an array of key values: ["key", "value"]
 * Example output: "Brand: "
 */
@Pipe({
    name: 'getGroupPrefix',
    standalone: true
})
export class GetGroupPrefixPipe implements PipeTransform {
    transform(facet: string[], facetGroups?: FacetGroup[], joinSymbol = ': '): string {
        if (!facetGroups?.length) {
            return facet[1];
        }

        const facetGroup = facetGroups.find(group => group.key === facet[0]) || {};

        if (facetGroup?.text) {
            return `${facetGroup.text}${joinSymbol}`;
        }

        return facet[1];
    }
}
